import type { TopProductData } from '../../../services/analyticsApi';
import './TopProductsList.css';

interface TopProductsListProps {
  data: TopProductData[];
}

const TopProductsList: React.FC<TopProductsListProps> = ({ data }) => {
  return (
    <div className="top-products-list">
      <h3 className="top-products-list__title">熱門商品</h3>
      <ul className="top-products-list__list">
        {data.map((item, index) => (
          <li key={item.productId} className="top-products-list__item">
            <span className="top-products-list__rank">{index + 1}</span>
            <span className="top-products-list__name">{item.title}</span>
            <span className="top-products-list__count">{item.views} 瀏覽</span>
          </li>
        ))}
        {data.length === 0 && (
          <li className="top-products-list__empty">沒有資料</li>
        )}
      </ul>
    </div>
  );
};

export default TopProductsList;
